import { GetServerSideProps } from 'next'
import React from 'react'

import { CampaignPage } from '@features/campaign/pages/CampaignPage'
import { WithCampaignPageProps } from '@features/campaign/pages/CampaignPage/interface'
import { AppLayout } from '@components/layouts/AppLayout'
import { OgShare } from '@components/OgShare'
import { maintenanceHandler } from '@lib/maintenanceHandler'

function Campaign(props: WithCampaignPageProps) {
  const { url } = props

  return (
    <AppLayout>
      <OgShare url={url} />
      <CampaignPage {...props} />
    </AppLayout>
  )
}

export const getServerSideProps: GetServerSideProps = async ({
  query,
  req,
}) => {
  if (Number.isNaN(Number(query?.campaignId))) {
    return {
      redirect: {
        destination: '/',
        permanent: false,
      },
    }
  }
  return maintenanceHandler({
    campaignId: Number(query?.campaignId),
    text: query.text || '',
    bookType: query.bookType || null,
    url: req.url,
  })
}

export default Campaign
